import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import BackToTop from 'vue-backtotop'
import datePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
import axios from 'axios'

 
Vue.prototype.$http = axios;

Vue.use(datePicker);
Vue.use(BackToTop)
Vue.use(BootstrapVue)

new Vue({
  el: 'app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js